import * as ngCore from '@angular/core'

import * as tag from '../../../../../tag'

/** Preserves the table list presentation used by the legacy renderer. */
@ngCore.Component({
  imports: [tag.Component],
  selector: 'atn-value-list',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** List value whose first item or details placeholder is displayed. */
  public readonly valueSg = ngCore.input.required<readonly unknown[]>({
    alias: 'value',
  })

  /** Whether the value needs the details placeholder. */
  public readonly hasMoreThanOneElSg = ngCore.computed(
    (value = this.valueSg()) => value.length > 1,
  )

  /** First item formatted for the tag component. */
  public readonly firstElValueSg = ngCore.computed((value = this.valueSg()) =>
    value[0]?.toString(),
  )
}
